import { Navigate, useLocation, useParams } from "react-router-dom";
import { useSub } from "../../../common/subscription/useSub";
import { urls } from "../../../urls";
import { ContractPage } from "./ContractPage";

export const ContractViewRoute = () => {
  const sub = useSub();
  const { contractId } = useParams();
  const location = useLocation();

  if (sub.hasSourcingEventV2Access && contractId) {
    return <Navigate to={`${urls.v2.contracts.view.go(contractId)}${location.search}${location.hash}`} replace />;
  }

  return <ContractPage />;
};
